import { useSetRecoilState } from 'recoil'

import { useQuery } from '@tanstack/react-query'

import {
  getEventInfoDetail,
  getEventInfoList,
  getEventInfoMain,
  getEventList,
} from '~/features/event-info/apis/event-info'
import { eventListState } from '~/shared/states'

const EVENT_INFO_KEYS = {
  base: [{ scope: 'event-info' }] as const,
  eventInfoList: () =>
    [{ ...EVENT_INFO_KEYS.base[0], entity: 'list' }] as const,
  main: (eventId: number) =>
    [{ ...EVENT_INFO_KEYS.base[0], entity: 'main', eventId }] as const,
  detail: (eventId: number) =>
    [{ ...EVENT_INFO_KEYS.base[0], entity: 'detail', eventId }] as const,
}

export const useEventInfoList = () => {
  const setEventList = useSetRecoilState(eventListState)

  return useQuery({
    queryKey: EVENT_INFO_KEYS.eventInfoList(),
    queryFn: async () => {
      const data = await getEventInfoList()
      setEventList(data)

      return data
    },
  })
}

export const useEventInfoMain = (eventId: number) => {
  return useQuery({
    queryKey: EVENT_INFO_KEYS.main(eventId),
    queryFn: () => getEventInfoMain(eventId),
    enabled: !!eventId,
  })
}

export const useEventInfoDetail = (eventId: number) => {
  return useQuery({
    queryKey: EVENT_INFO_KEYS.detail(eventId),
    queryFn: () => getEventInfoDetail(eventId),
  })
}

export const useEventList = () => {
  return useQuery({
    queryKey: EVENT_INFO_KEYS.eventInfoList(),
    queryFn: () => getEventList(),
  })
}
